import { render, staticRenderFns } from "./TabAndamento.vue?vue&type=template&id=b132cc46&"
import script from "./TabAndamento.vue?vue&type=script&lang=js&"
export * from "./TabAndamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports